import { render, staticRenderFns } from "./HelpPopup.vue?vue&type=template&id=5841d8ef&"
import script from "./HelpPopup.vue?vue&type=script&lang=js&"
export * from "./HelpPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports